import { Skeleton, Typography } from '@mui/material';
import { CommonCellProps } from './cells.props';

const DealDueCell = ({ valuationRow }: CommonCellProps) => {
  if (valuationRow.is_loading_additional_data) {
    return <Skeleton variant="text" width="80%" height={20} />;
  }

  return (
    <Typography variant="body2">
      {valuationRow.deal_due || '-'}
    </Typography>
  );
};

export default DealDueCell;

